import React from 'react';
import CloseButton from '../CloseButton';
import Heading from '../Heading';
import { st, classes } from './MessageBoxFunctionalLayout.st.css';
import { dataHooks } from './constants';
import Box from '../Box';

const Header = ({
  title,
  onCancel,
  theme = 'blue',
  closeButton = true,
  size = 'medium',
  newColorsBranding = false,
}) => {
  return (
    <>
      <div
        className={st(classes.header, { theme, newColorsBranding })}
        data-hook={dataHooks.header}
      >
        <Heading
          size={size}
          light={!newColorsBranding}
          className={classes.heading}
          dataHook={dataHooks.headerTitle}
        >
          {title}
        </Heading>
        {closeButton && !newColorsBranding ? (
          <CloseButton
            dataHook={dataHooks.headerCloseButton}
            size={newColorsBranding ? 'large' : 'medium'}
            skin={newColorsBranding ? 'dark' : 'lightFilled'}
            onClick={onCancel}
          />
        ) : null}
      </div>
      {closeButton && newColorsBranding ? (
        <Box className={classes.controlButtons}>
          <CloseButton
            dataHook={dataHooks.headerCloseButton}
            size={newColorsBranding ? 'large' : 'medium'}
            skin={newColorsBranding ? 'dark' : 'lightFilled'}
            onClick={onCancel}
          />
        </Box>
      ) : null}
    </>
  );
};

export default Header;
